var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.4C12.868 5.4 13.7004 5.77928 14.3142 6.45442C14.9279 7.12955 15.2727 8.04522 15.2727 9C15.2727 9.95478 14.9279 10.8705 14.3142 11.5456C13.7004 12.2207 12.868 12.6 12 12.6C11.132 12.6 10.2996 12.2207 9.68583 11.5456C9.07208 10.8705 8.72727 9.95478 8.72727 9C8.72727 8.04522 9.07208 7.12955 9.68583 6.45442C10.2996 5.77928 11.132 5.4 12 5.4ZM12 0C17.4545 0 22.1127 3.732 24 9C22.1127 14.268 17.4545 18 12 18C6.54545 18 1.88727 14.268 0 9C1.88727 3.732 6.54545 0 12 0ZM2.37818 9C4.17818 13.032 7.89818 15.6 12 15.6C16.1018 15.6 19.8218 13.032 21.6218 9C19.8218 4.968 16.1018 2.4 12 2.4C7.89818 2.4 4.17818 4.968 2.37818 9Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.f4a68379faac4ecdd0578559d0a90a02.svg";
export { ForwardRef as ReactComponent };